export function scrollNodeToBottom(node) {
  window.requestAnimationFrame(
    () => node && (node.scrollTop = node.scrollHeight)
  )
}

export function stopPropagation(ev) {
  return ev && ev.stopPropagation()
}
